import { jsx } from "react/jsx-runtime";
import Button from "./Button.js";
import classnames from "classnames";
import { useState } from "react";
function AsyncButton(props) {
    const { onClick } = props || {};
    const [loading, setLoading] = useState(false);
    const handleClick = async (e)=>{
        if (!onClick) return;
        const result = onClick(e);
        if (result instanceof Promise) {
            setLoading(true);
            try {
                await result;
            } finally{
                setLoading(false);
            }
        }
    };
    return /*#__PURE__*/ jsx(Button, {
        loading: loading,
        ...props,
        onClick: handleClick,
        className: classnames(props.className)
    });
}
export { AsyncButton as default };
